import React, { useState } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@common-ui/ui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkItemImageHeader from './WorkItemImageHeader';
import DisplayImage from './DisplayImage';
import ImageInfo from './ImageInfo';
import MarkerInfo from './MarkerInfo';
import workItemEnum from '../../enums/workItemEnum';
import WorkItemPhotoNotes from './WorkItemPhotoNotes';
import buildImageInfo from '../../utils/buildImageInfo';
import WorkItemTextNotes from './WorkItemTextNotes';

const ImagePreviewSection = ({ image }) => (
  <div className="workItem__imagePreviewSection">
    <DisplayImage image={[image?.preview]} header={workItemEnum.THERMAL_IMAGE} />
    <DisplayImage image={[image?.visual]} header={workItemEnum.VISIBLE_LIGHT_IMAGE} />
  </div>
);

export const WorkItemImageDetails = ({ image }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    image && (
      <div className="work-item__image">
        <WorkItemImageHeader image={image} />
        <ImagePreviewSection image={image} />
        <MarkerInfo markerData={image.imageJSON.marker_info} />
        <WorkItemPhotoNotes image={image.photonotes} />
        <Accordion elevation={2} sx={accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#2B7CD3' }} />}
            id="workItemAccordion"
            onClick={() => setExpanded(!expanded)}
          >
            <Typography sx={accordionText}>
              View {expanded ? workItemEnum.LESS : workItemEnum.MORE}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ImageInfo image={buildImageInfo(image?.imageJSON)} />
            <WorkItemTextNotes imageInfo={image} />
          </AccordionDetails>
        </Accordion>
      </div>
    )
  );
};

const accordion = {
  mt: 2,
};

const accordionText = { flexGrow: '0 !important', color: '#2B7CD3' };
